<template>
  <div class="form-group">
    <label class="form-label">{{ label }}</label>
    <input type="color"
           style="border-radius: 0"
           class="form-control"
           :placeholder="label"
           @input="handleInput"
           @keyup.enter="$emit('enter')"
           :readonly="readonly ? readonly : false"
           :value="value"/>
  </div>
</template>

<script>
export default {
  name: "InputColorGroup",
  data() {
    return {
      content: this.value
    }
  },
  props: {
    label: {},
    value: {},
    type: {},
    readonly: {}
  },
  mounted() {
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
